import { render } from "./Principal.vue?vue&type=template&id=7b4f40c9&ts=true"
import script from "./Principal.vue?vue&type=script&lang=ts"
export * from "./Principal.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__